import React, { useEffect, useState } from "react";
import TopAppBar from "../../components/TopAppBar";
import Layout from "../../components/Layout";
import MainLayout from "../../layouts/MainLayout";
import { useContentStore } from "../../stores/contentStore";
import { locale } from "../../utils/LocaleManager";
import { useNavigate, useParams } from "react-router-dom";
import {
  deleteContentByID,
  editVideo,
  getThumbnailByVideoID,
  getVideoByID,
  getVideoFromDB,
} from "../../services/contentServices";
import {
  DeleteTags,
  EditTags,
  EditVideo,
  NewTags,
} from "../../models/editDetails";
import { Bounce, toast } from "react-toastify";
import {
  Box,
  Card,
  CardContent,
  Stack,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";
import DialogBox from "../../components/DialogBox";
import DataTable from "../../components/DataTable";
import {
  convertTimeString,
  handleError,
  toPercentage,
} from "../../utils/utilFunctions";
import TextFieldInput from "../../components/Textfield";
import { StyledLabelContainer } from "./styled";
import { useRolePermissionsStore } from "../../stores/rolePermissionsStore";
import {
  antiFlashWhite,
  black,
  darkLimeGreen,
  strongOrange,
  vividRed,
} from "../../utils/StyleHelpers";

let errorShowed: any = null;

const EditScreen = () => {
  const rolePermissions = useRolePermissionsStore(
    (state) => state.rolePermissions,
  );
  const isShowEdit = useContentStore((state: any) => state.isShowEdit);
  const setSearchKeyword = useContentStore(
    (state: any) => state.setSearchKeyword,
  );
  const setSearchKeywordTemp = useContentStore(
    (state: any) => state.setSearchKeywordTemp,
  );
  const setSelectedThumbnails = useContentStore(
    (state: any) => state.setSelectedThumbnails,
  );
  const selectedThumbnails = useContentStore(
    (state: any) => state.selectedThumbnails,
  );
  const isShowDeleteDialog = useContentStore(
    (state: any) => state.isShowDeleteDialog,
  );
  const setIsShowDeleteDialog = useContentStore(
    (state: any) => state.setIsShowDeleteDialog,
  );
  const setIsShowDetails = useContentStore(
    (state: any) => state.setIsShowDetails,
  );
  const setIsShowPlayer = useContentStore(
    (state: any) => state.setIsShowPlayer,
  );
  const setSelectedTime = useContentStore(
    (state: any) => state.setSelectedTime,
  );
  const setSelectedCurrentTime = useContentStore(
    (state: any) => state.setSelectedCurrentTime,
  );
  const setIsModify = useContentStore((state: any) => state.setIsModify);
  const setIsShowEdit = useContentStore((state: any) => state.setIsShowEdit);
  const isLoading = useContentStore((state: any) => state.isLoading);
  const setIsLoading = useContentStore((state: any) => state.setIsLoading);
  const selectedTime = useContentStore((state: any) => state.selectedTime);
  const tagDetails = useContentStore((state: any) => state.tagDetails);
  const setTagDetails = useContentStore((state: any) => state.setTagDetails);
  const isModify = useContentStore((state: any) => state.isModify);
  const setIsSelected = useContentStore((state: any) => state.setIsSelected);
  const setFilterTypes = useContentStore((state: any) => state.setFilterTypes);
  const [videoUrl, setVideoUrl] = useState("");
  const [videoTitle, setVideoTitle] = useState("");
  const [time, setTime] = useState("");
  const [type, setType] = useState("Label");
  const [tag, setTag] = useState("");
  const [title, setTitle] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [tagId, setTagId] = useState("");
  const [oldType, setOldType] = useState("");
  const [oldTag, setOldTag] = useState("");
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
  const [tagDisabled, setTagDisabled] = useState(false);
  const [typeDisabled, setTypeDisabled] = useState(false);
  const [isCancelDisabled, setIsCancelDisabled] = useState(false);
  const selectedThumbnailUrl = React.useRef("");

  const navigate = useNavigate();

  const { videoId, searchKeyword }: any = useParams();

  useEffect(() => {
    return () => {
      if (selectedThumbnailUrl.current)
        URL.revokeObjectURL(selectedThumbnailUrl.current);
    };
  }, []);

  const onCancel = () => {
    navigate("/main");
    setIsShowEdit(false);
    setIsShowDetails(false);
    setIsShowPlayer(false);
    setIsSelected(false);
    setSearchKeyword("");
    setSearchKeywordTemp("");
    setSelectedThumbnails([]);
    setVideoUrl("");
    setIsModify(false);
    setSelectedTime("00:00:00");
    setSelectedCurrentTime("");
    setFilterTypes("");
  };

  const onSave = async () => {
    if (!rolePermissions?.video?.edit) return;

    const editVideoRequest: EditVideo = {
      videoIndexId: videoId,
      name: title,
      description: title,
      newTags: tagDetails
        .filter((item: any) => !item.tagId)
        .map((item: any) => {
          const newTag: NewTags = {
            type: item.type,
            tag: item.name,
            start: item.start,
            end: item.end,
          };

          return newTag;
        }),
      deleteTags: tagDetails
        .filter((item: any) => item.deleted)
        .map((item: any) => {
          const deleteTag: DeleteTags = {
            tagId: item.tagId,
            type: item.type,
            tag: item.name,
          };

          return deleteTag;
        }),
      editTags: tagDetails
        .filter((item: any) => item.modified)
        .map((item: any) => {
          const editTag: EditTags = {
            tagId: item.tagId,
            type: item.type,
            oldType: item.oldType,
            oldTag: item.oldTag,
            tag: item.name,
            start: item.start,
            end: item.end,
          };

          return editTag;
        }),
    };
    setShowConfirmation(false);
    setIsCancelDisabled(true);
    toast.warn("You cannot cancel because saving is in progress", {
      position: "bottom-left",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      pauseOnFocusLoss: false,
      draggable: true,
      progress: undefined,
      theme: "colored",
      transition: Bounce,
    });
    await editVideoService(editVideoRequest);
    onHandleCancel();
    fetchData(videoId);
  };

  const sortTags = function (a: any, b: any) {
    if (convertTimeString(a.start) === convertTimeString(b.start)) {
      return b.confidence - a.confidence;
    }
    return convertTimeString(a.start) > convertTimeString(b.start) ? 1 : -1;
  };

  const clearForm = () => {
    setTag("");
    setType("");
    setTime("00:00:00");
    setIsModify(false);
    setIsSelected(false);
  };

  const onHandleCancel = () => {
    clearForm();
    setTagDetails(tagDetails.slice(0));
  };

  const onHandleClick = () => {
    const details = {
      type: type,
      name: tag,
      start: time,
      end: time,
    };

    const newDetails = [
      {
        type: type,
        name: tag,
        start: time,
        end: time,
        confidence: 1,
      },
    ];

    if (!isModify) {
      setTagDetails([...newDetails, ...tagDetails].sort(sortTags));
      clearForm();
      return;
    }

    const edit = {
      tagId: tagId,
      oldType: oldType === details.type ? "" : oldType,
      oldTag: oldTag === details.name ? "" : oldTag,
      confidence: selectedRow.confidence,
      ...details,
    };

    const isModified = oldType !== details.type || oldTag !== details.name;
    const tempDetails = tagDetails.slice(0);
    const index = tempDetails.findIndex((item: any) => item === selectedRow);
    tempDetails[index] = selectedRow.tagId
      ? { ...edit, modified: isModified, deleted: false }
      : { ...details, confidence: 1 };
    setTagDetails(tempDetails.sort(sortTags));
    clearForm();
  };

  const fetchData = async (videoId: any) => {
    const getUrl = await getVideoByID(videoId);
    if (getUrl.status === 200) {
      const data = getUrl.data;
      setVideoUrl(data);
    } else {
      const errStatus = getUrl?.response?.status;
      handleError({
        status: errStatus,
        toast,
        errorMessage: "Error: Video might be deleted or not available.",
        onClose: () => {},
      });
      if (errStatus === 403) {
        setIsLoading(false);
        onCancel();
        return;
      }
      if (errStatus === 401) {
        setIsLoading(false);
        return;
      }
    }

    const getDetails = await getVideoFromDB(videoId);
    if (getDetails.status === 200) {
      const data = getDetails.data;
      const thumbnail = await getThumbnailByVideoID(videoId);
      if (selectedThumbnailUrl.current)
        URL.revokeObjectURL(selectedThumbnailUrl.current);
      selectedThumbnailUrl.current =
        thumbnail instanceof Blob ? URL.createObjectURL(thumbnail) : "";
      setVideoTitle(data.name);
      setTagDetails(data.tags.sort(sortTags));
      setSelectedThumbnails([
        {
          videoIndexId: videoId,
          image: selectedThumbnailUrl.current,
          name: data.name,
        },
      ]);
    } else {
      const errStatus = getDetails?.response?.status;
      handleError({
        status: errStatus,
        toast,
        errorMessage: "Error: Video might be deleted or not available.",
        onClose: () => {},
      });
      if (errStatus === 403) {
        setIsLoading(false);
        onCancel();
        return;
      }
      if (errStatus === 401) {
        setIsLoading(false);
        return;
      }
    }
    setIsLoading(false);
  };

  const editVideoService = async (editVideoRequest: EditVideo) => {
    const requestEditVideo = await editVideo(editVideoRequest);

    if (requestEditVideo.status === 200) {
      //setShowConfirmation(false);
      toast.success("Saved Successfully", {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
        onClose: () => {
          setIsCancelDisabled(false);
        },
      });
    } else {
      handleError({
        status: requestEditVideo.response.status,
        toast,
        errorMessage: `Error: Encountered an error. (CODE: ${requestEditVideo.code})`,
        onClose: () => {},
      });
    }
  };

  const onCopyLinks = async () => {
    toast.warning(`Processing: Copying link`, {
      position: "bottom-left",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: true,
      pauseOnFocusLoss: false,
      progress: undefined,
      theme: "colored",
      transition: Bounce,
    });

    const copied = await getVideoByID(videoId);

    if (copied.status === 200) {
      navigator.clipboard.writeText(copied.data);
      toast.success("Video Link Copied", {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } else {
      handleError({
        status: copied.response.status,
        toast,
        errorMessage: "Error: Encountered an error while copying link.",
        onClose: () => {},
      });
    }
  };

  const renderDeleteDialog = () => {
    return (
      <Box sx={{ width: "100%" }}>
        <Stack spacing={1}>
          {selectedThumbnails.map((thumbnail: any) => (
            <Card key={thumbnail.videoIndexId} variant="outlined" style={{ color: "#666", fontSize: "20px", fontWeight: 400, lineHeight: "28px" }}>
              <CardContent style={{ padding: "1.25rem" }}>
                <Stack direction="row" gap="0.625rem">
                  <img
                    src={thumbnail.image}
                    style={{
                      height: "auto",
                      width: "2.5rem",
                      borderRadius: "0.25rem",
                      alignSelf: "stretch",
                    }}
                    alt={thumbnail.name}
                  />
                  {thumbnail.name}
                </Stack>
              </CardContent>
            </Card>
          ))}
        </Stack>
      </Box>
    );
  };

  const TableHeader = (text: string) => {
    return (
      <TableCell
        style={{
          color: black,
          textOverflow: "ellipsis",
          fontSize: "1rem",
          fontWeight: 600,
          lineHeight: "normal",
          backgroundColor: antiFlashWhite,
        }}
        align="center"
      >
        {text}
      </TableCell>
    );
  };

  const handleColor = (tag: any) => {
    if (!tag?.tagId) return darkLimeGreen;

    if (tag?.tagId && tag.deleted) return vividRed;

    if (tag?.tagId && tag.modified) return strongOrange;
  };

  const renderNumber = (index: number) => {
    return index + 1;
  };

  const renderDataTable = () => {
    return (
      <DataTable
        minWidth={535}
        label="details table"
        tableHeader={
          <>
            <TableCell style={{ backgroundColor: antiFlashWhite }}>
              {locale.hashtag}
            </TableCell>
            {TableHeader(locale.timestamp)}
            {TableHeader(locale.type)}
            {TableHeader(locale.tag)}
            {TableHeader(locale.confidence)}
          </>
        }
        tableBody={
          <TableBody>
            {tagDetails
              ?.filter(
                (item: any) => !item?.tagId || item.deleted || item.modified,
              )
              ?.map((item: any, index: any) => (
                <TableRow
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    cursor: "pointer",
                  }}
                  key={index}
                  hover={true}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    style={{ color: handleColor(item) }}
                  >
                    {renderNumber(index)}
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ color: handleColor(item) }}
                  >
                    {convertTimeString(item.start)}
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ color: handleColor(item) }}
                  >
                    {item.type}
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ color: handleColor(item) }}
                  >
                    {item.name}
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ color: handleColor(item) }}
                  >
                    {toPercentage(item.confidence)}%
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        }
      />
    );
  };

  const renderDialog = () => {
    const tags = tagDetails?.filter(
      (item: any) => !item?.tagId || item.deleted || item.modified,
    ).length;
    const changeTitle = videoTitle !== title;

    if (tags && changeTitle) {
      return (
        <>
          <StyledLabelContainer>
            <TextFieldInput
              disabled
              label="Video-Title"
              defaultValue={title}
              value={title}
              variant="filled"
            />
          </StyledLabelContainer>

          {renderDataTable()}
        </>
      );
    }

    if (changeTitle) {
      return (
        <TextFieldInput
          disabled
          label="Video-Title"
          defaultValue={title}
          value={title}
          variant="filled"
        />
      );
    }

    if (tags) {
      return renderDataTable();
    }
  };

  const deleteVideos = async () => {
    if (!rolePermissions?.video?.delete) return;

    setIsShowDeleteDialog(false);
    toast.warning(`Processing: Deleting 1 video/s`, {
      position: "bottom-left",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: true,
      pauseOnFocusLoss: false,
      progress: undefined,
      theme: "colored",
      transition: Bounce,
    });

    const deleted = await deleteContentByID(videoId);

    if (deleted.status === 200) {
      toast.success("Video Deleted", {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
        onClose: () => {
          window.location.assign("/main");
        },
      });
      setIsLoading(true);
    } else {
      handleError({
        status: deleted.response.status,
        toast,
        errorMessage: `Error: Encountered an error while deleting the video (CODE: ${deleted.code})`,
        onClose: () => {},
      });
    }
  };

  const onDownload = () => {
    let toastProcessing = toast.warning(
      "Processing: Generating Download links...",
      {
        position: "bottom-left",
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: true,
        progress: undefined,
        autoClose: false,
        theme: "colored",
        transition: Bounce,
      },
    );

    Promise.allSettled(
      selectedThumbnails.map(async (selected: any) => {
        const getUrl = await getVideoByID(selected.videoIndexId);
        if (getUrl.status === 200) {
          const data = getUrl.data;

          await fetch(data, {
            headers: new Headers({
              Origin: window.location.origin,
            }),
            mode: "cors",
          })
            .then((response) => response.blob())
            .then((blob) => {
              let blobUrl = window.URL.createObjectURL(blob);
              var link = document.createElement("a");
              link.href = blobUrl;
              link.download = selected.name;
              link.click();

              toast.success(
                `Success: Download link generated for: ${selected.name}`,
                {
                  position: "bottom-left",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: false,
                  pauseOnFocusLoss: false,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                  transition: Bounce,
                },
              );
            })
            .catch((e) => {
              toast.error(
                `Error: Encountered issue downloading: ${selected.name}`,
                {
                  position: "bottom-left",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: false,
                  pauseOnFocusLoss: false,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                  transition: Bounce,
                },
              );
            });
        } else {
          handleError({
            status: getUrl.response.status,
            toast,
            errorMessage: "Error: Video might be deleted or not available",
            onClose: () => {},
          });
        }
      }),
    ).then(() => toast.dismiss(toastProcessing));
  };

  const onClickDetails = async () => {
    const getUrl = await getVideoByID(videoId);
    if (getUrl.status === 200) {
      const data = getUrl.data;
      setVideoUrl(data);
      setIsShowPlayer(true);
      navigate(
        "/details/" + videoId + (searchKeyword ? "/" + searchKeyword : ""),
      );
      setIsShowDetails(true);
    } else {
      setSelectedThumbnails([]);
      handleError({
        status: getUrl.response.status,
        toast,
        errorMessage: "Error: Video might be deleted or not available.",
        onClose: () => (errorShowed = null),
      });
    }
  };

  const handleSaveConfirmation = () => {
    const hasModifiedTags = tagDetails?.some(
      (item: any) => !item?.tagId || item.deleted || item.modified,
    );

    const hasTitleChanged = videoTitle !== title;

    if (hasModifiedTags || hasTitleChanged) {
      setShowConfirmation(true);
      return;
    }
    toast.warn("There are no changes made.", {
      position: "bottom-left",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: true,
      pauseOnFocusLoss: false,
      progress: undefined,
      theme: "colored",
      transition: Bounce,
    });
  };

  const handleCancelConfirmation = () => {
    const hasModifiedTags = tagDetails?.some(
      (item: any) => !item?.tagId || item.deleted || item.modified,
    );

    const hasTitleChanged = videoTitle !== title;

    if (hasModifiedTags || hasTitleChanged) {
      setShowCancelConfirmation(true);
      return;
    }

    onCancel();
  };

  const saveDialogBody = () => {
    const tags = tagDetails?.filter(
      (item: any) => !item?.tagId || item.deleted || item.modified,
    ).length;
    const changeTitle = videoTitle !== title;

    if (tags && changeTitle) {
      return locale.save_dialog_body;
    }

    if (tags) {
      return locale.save_tags_body;
    }

    if (changeTitle) {
      return locale.save_title_body;
    }
  };

  const cancelDialogbody = () => {
    const tags = tagDetails?.filter(
      (item: any) => !item?.tagId || item.deleted || item.modified,
    ).length;
    const changeTitle = videoTitle !== title;

    if (tags && changeTitle) {
      return locale.cancel_dialog_body;
    }

    if (tags) {
      return locale.cancel_tags_body;
    }

    if (changeTitle) {
      return locale.cancel_title_body;
    }
  };

  const selectedItemRow = (tagSelected: any) => {
    setSelectedRow(tagSelected);
    setTag(tagSelected.name);
    setType(tagSelected.type);
    setTagId(tagSelected.tagId);
    setOldType(tagSelected.oldType ? tagSelected.oldType : tagSelected.type);
    setOldTag(tagSelected.oldTag ? tagSelected.oldTag : tagSelected.name);
    setTagDisabled(false);
    setTypeDisabled(false);
    if (tagSelected.deleted) {
      setTag("");
      setType("Label");
      setTagDisabled(true);
      setTypeDisabled(true);
      setIsModify(false);
    }
  };

  const onPlayerError = (e: any) => {
    if (errorShowed !== null || e.code === 7000) return;
    errorShowed = toast.error(
      "Error: Video might be deleted or not available",
      {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: true,
        pauseOnFocusLoss: false,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
        onClose: () => (errorShowed = null),
      },
    );
  };

  useEffect(() => {
    setIsLoading(true);
    setIsShowEdit(true);
    setTitle(videoTitle);
    if (videoId) fetchData(videoId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoId, videoTitle]);

  useEffect(() => {
    if (selectedTime) setTime(selectedTime);
  }, [selectedTime]);

  useEffect(() => {
    if (tag) setDisabled(false);
    if (!tag) setDisabled(true);
  }, [tag]);

  useEffect(() => {
    if (isModify) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [isModify]);

  return (
    <>
      <TopAppBar
        isEditDetails={isShowEdit}
        pageTitle={locale.edit_video_details}
        btnSave={locale.save}
        onSave={() => handleSaveConfirmation()}
        btnCancel={locale.cancel}
        onCancel={() => handleCancelConfirmation()}
        isCancelDisabled={isCancelDisabled ? "disabled" : ""}
      />
      <MainLayout>
        {!isLoading ? (
          <Layout
            url={videoUrl}
            label={locale.video_title}
            tagLabel={locale.tag}
            title={title}
            tagDetails={tagDetails}
            searchKeyword={searchKeyword}
            onCopyLinks={() => onCopyLinks()}
            onDownload={() => onDownload()}
            onClickDetails={() => onClickDetails()}
            btnLabel={isModify ? locale.modify : locale.add}
            onHandleClick={() => onHandleClick()}
            time={time}
            type={type}
            tag={tag}
            setTime={setTime}
            setType={setType}
            setTag={setTag}
            setTitle={setTitle}
            btnDisabled={disabled}
            onHandleCancel={() => onHandleCancel()}
            onSelectedRow={(e: any) => selectedItemRow(e)}
            isShowEdit={true}
            tagDisabled={tagDisabled}
            typeDisabled={typeDisabled}
            onPlayerError={onPlayerError}
          />
        ) : (
          <></>
        )}
      </MainLayout>
      {isShowDeleteDialog ? (
        <DialogBox
          header={locale.deleteHeader}
          body={<div>{locale.deleteBody}</div>}
          subBody={renderDeleteDialog()}
          onCancel={() => setIsShowDeleteDialog(false)}
          onSubmit={() => deleteVideos()}
          isDelete={true}
          primaryButton={locale.yes}
          secondaryButton={locale.no}
        ></DialogBox>
      ) : (
        <></>
      )}
      {showConfirmation ? (
        <DialogBox
          header={locale.save_header}
          body={<div>{saveDialogBody()}</div>}
          subBody={renderDialog()}
          onCancel={() => setShowConfirmation(false)}
          onSubmit={() => onSave()}
          isDelete={false}
          primaryButton={locale.yes}
          secondaryButton={locale.no}
        ></DialogBox>
      ) : (
        <></>
      )}

      {showCancelConfirmation ? (
        <DialogBox
          header={locale.cancel_header}
          body={<div>{cancelDialogbody()}</div>}
          subBody={renderDialog()}
          onCancel={() => setShowCancelConfirmation(false)}
          onSubmit={() => onCancel()}
          isDelete={true}
          primaryButton={locale.yes}
          secondaryButton={locale.no}
        ></DialogBox>
      ) : (
        <></>
      )}
    </>
  );
};

export default EditScreen;
